import { filterImagesBySelector } from 'pathfinder/modules/ImageGalleryIcon/utils/filterImagesBySelector';
export const getFilteredImages = (elementsWithProperSize) => {
    // filter images that belong to gallery
    const galleryImagesFiltered = elementsWithProperSize.filter((el) => {
        return filterImagesBySelector(el, '.wikia-gallery-item');
    });
    // filter images inside a table
    return galleryImagesFiltered.filter((el) => {
        return filterImagesBySelector(el, 'table');
    });
};
